export default __webpack_public_path__ + "static/media/apple-macbook.a924d805.jpg";